import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const StartDateCell = React.memo((row: PurchaseOrders) => (
  <Tooltip arrow title={row.postart ?? ''}>
    <Typography noWrap variant="body2">
      {row?.postart}
    </Typography>
  </Tooltip>
));

export default StartDateCell;
